<template>
    <div style="display: flex; flex-direction: column; gap: 16px;" v-if="events.summary">
        <div class="card-body px-0 pt-0 pb-2 table-with-search">

            <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0 ant-table-two-container survey-container" style="border: none !important;">
                <div class="table-spinner-container" v-if="dataLoading">
                    <div class="spinner"/>
                </div>
                <div style="display: flex; flex-direction: column; gap: 16px;" v-if="events.summary">
                    <div class="card-body px-0 pt-0 pb-2 table-with-search">
            
                        <div class="card content-wrap-card col-sm-12 col-xs-12 tableCard p-0 ant-table-two-container survey-container" style="border: none !important;">
                            <div class="table-spinner-container" v-if="dataLoading">
                                <div class="spinner"/>
                            </div>
                            <div class="survey-summary-container">
                                <div class="summary-left">
                                    <div
                                    >
                                        <card-container
                                        title="전체 누적 이벤트 현황"
                                        needsBorder
                                    >
                                        <template #button>
                                            <a-button
                                                shape="circle"
                                                @click.prevent="uiHandler.downloadPdf($event, 0)"
                                            >
                                                <template #icon>
                                                    <i class="fa-solid fa-down-to-bracket"/>
                                                </template>
                                            </a-button>
                                        </template>
                                        <div class="stats-row single" ref="chart0">
                                            <stat-container
                                                title="메시지 총 발송 건수"
                                                :number="events.summary.list[0]?.totalSent || 0"
                                                unit="건"
                                            />
                                            <div style="display: flex; gap: 42px; align-items: start;">
                                                <stat-container
                                                    title="응답자 수"
                                                    :number="events.summary.list[0]?.responseCount || 0"
                                                    unit="건"
                                                />
                                                <items-container
                                                    :smile-count="events.summary.list[0]?.smileCount || 0"
                                                    :smile-pro-count="events.summary.list[0]?.smileProCount || 0"
                                                />
                                            </div>
                                            <div style="width: 100%; height: 200px; max-width: 300px;">
                                                <Pie
                                                    :data="charts.itemRatioChart.data" 
                                                    :options="charts.itemRatioChart.options" 
                                                    :key="charts.itemRatioChart.chartKey"    
                                                />
                                            </div>
                                            <stat-container
                                                title="참여율"
                                                :number="participationRate || 0"
                                                unit="%"
                                                style="margin-right: 60px;"
                                            />
                                        </div>
                                    </card-container>
                                    </div>
                                    <card-container
                                        title="시간대별 인증서 발행 및 응모자 추이"
                                        needsBorder
                                    >
                                        <template #button>
                                            <a-button
                                                shape="circle"
                                                @click.prevent="uiHandler.downloadPdf($event, 1)"
                                            >
                                                <template #icon>
                                                    <i class="fa-solid fa-down-to-bracket"/>
                                                </template>
                                            </a-button>
                                        </template>
                                        <div ref="chart1">
                                            <div class="stats-row">
                                                <div class="stats-column half">
                                                    <div class="stats-row double">
                                                        <stat-container
                                                            title="메시지 총 발송 건수"
                                                            :number="events.summary.list[0]?.totalSent || 0"
                                                            unit="건"
                                                        />
                                                        <!-- <growth-container
                                                            :value="events.summary.list[0]?.totalSentGrowth.percentChange"
                                                        /> -->
                                                    </div>
                                                    <div class="stats-row double" style="opacity: 0;">
                                                        <items-container
                                                            :smile-count="events.summary.list[0]?.smileCount || 0"
                                                            :smile-pro-count="events.summary.list[0]?.smileProCount || 0"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="stats-column half">
                                                    <div class="stats-row double">
                                                        <stat-container
                                                            title="응답자 수"
                                                            :number="events.summary.list[0]?.responseCount || 0"
                                                            unit="건"
                                                        />
                                                        <!-- <growth-container
                                                            :value="events.summary.list[0]?.responseCountGrowth.percentChange"
                                                        /> -->
                                                        <items-container
                                                            :smile-count="events.summary.list[0]?.smileCount || 0"
                                                            :smile-pro-count="events.summary.list[0]?.smileProCount || 0"
                                                        />
                                                    </div>
                                                    <div class="stats-row double">
                                                   
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="stats-row">
                                                <div style="width: 100%; min-height: 300px; padding: 16px;">
                                                    <Bar 
                                                        :data="charts.hourlyChart.data" 
                                                        :options="charts.hourlyChart.options" 
                                                        :key="charts.hourlyChart.chartKey"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </card-container>
                                    <div style="display: flex; gap: 20px; flex: 1">
                                        <card-container
                                            :title="'수술 경과 기간별 응답률'"
                                            needsBorder
                                            style="width: 400px;"
                                        >
                                            <template #button>
                                                <a-button
                                                    shape="circle"
                                                    @click.prevent="uiHandler.downloadPdf($event, 2)"
                                                >
                                                    <template #icon>
                                                        <i class="fa-solid fa-down-to-bracket"/>
                                                    </template>
                                                </a-button>
                                            </template>
                                            <div class="surgery-duration-response-container" ref="chart2">
                                                <div class="rank-description multi">
                                                    총 응답자 <span class="desc-highlight-text">{{ formatCommaNumber(events.summary.list[0]?.responseCount) }}</span>명 중 응답자 수술 경과 분포입니다.<br/>
                                                    수술 후 <span class="desc-highlight-text">{{ displayValues.afterSurgery.afterSurgeryResponseMostLabel}}</span> 환자의 응답률이 가장 높아요.
                                                </div>
                                                <div class="bar-chart-container" style="padding: 20px;">
                                                    <Pie
                                                        :data="charts.recoveryChart.data" 
                                                        :options="charts.recoveryChart.options" 
                                                        :key="charts.recoveryChart.chartKey"
                                                    />
                                                </div>
                                            </div>
                                        </card-container>
                                        <card-container
                                            title="참여자 성별 및 나이 분포"
                                            needsBorder
                                            style="flex: 1;"
                                        >
                                            <template #button>
                                                <a-button
                                                    shape="circle"
                                                    @click.prevent="uiHandler.downloadPdf($event, 3)"
                                                >
                                                    <template #icon>
                                                        <i class="fa-solid fa-down-to-bracket"/>
                                                    </template>
                                                </a-button>
                                            </template>
                                            <div ref="chart3">
                                                <div class="chart-right-description">
                                                    이벤트 응모자 성별은 남성 
                                                    <span class="desc-highlight-text">{{ displayValues.gender.maleRatio }}%</span>
                                                    , 여성 
                                                    <span class="desc-highlight-text">{{ displayValues.gender.femaleRatio }}%</span>
                                                    입니다. 연령대는 
                                                    <span class="desc-highlight-text">{{ displayValues.age.topAgeLabel }}</span>
                                                    가 
                                                    <span class="desc-highlight-text">{{ formatCommaNumber(displayValues.age.topAgeValue) }}</span>
                                                    명으로 가장 많아요.
                                                </div>
                                                <div style="display: flex;">
                                                    <div style="flex: 1; padding: 20px;">
                                                        <Doughnut
                                                            :data="charts.genderChart.data" 
                                                            :options="charts.genderChart.options" 
                                                            :key="charts.genderChart.chartKey"
                                                        />
                                                    </div>
                                                    <div style="flex: 1; padding: 20px;">
                                                        <Doughnut
                                                            :data="charts.ageChart.data" 
                                                            :options="charts.ageChart.options" 
                                                            :key="charts.ageChart.chartKey"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </card-container>
                                    </div>
                                    <div style="display: flex; gap: 20px; flex: 1">
                                        <card-container
                                            needsBorder
                                            style="flex: 1"
                                        >
                                            <template #button>
                                                <a-button
                                                    shape="circle"
                                                    @click.prevent="uiHandler.downloadPdf($event, 4)"
                                                >
                                                    <template #icon>
                                                        <i class="fa-solid fa-down-to-bracket"/>
                                                    </template>
                                                </a-button>
                                            </template>
                                            <template #title>
                                                <div class="card-title-container">
                                                    <div class="question-chip">Q1</div>스마일 라식 중 자이스 스마일과 스마일 프로를 안과 방문 전 들어본 적 있나요?
                                                </div>
                                            </template>
                                            <div ref="chart4" style="height: 100%;">
                                                <div
                                                    class="rank-description multi"
                                                    v-for="item in surveyResultsArray.Q1"
                                                >
                                                    {{ item.question === 'yes' ? '들어본 적 있다' : '들어본 적 없다' }}
                                                    <span class="desc-highlight-text">{{ item.count }}명</span>
                                                    <span class="desc-highlight-text">{{ item.ratio }}</span>
                                                </div>
                                                <div 
                                                    class="chart-description-container"
                                                    style="padding: 0px; height: 500px; display: flex; align-items: center;"
                                                >
                                                    <div class="chart-container" style="padding-top: 40px;">
                                                        <Doughnut
                                                            :data="charts.q1Chart.total.data" 
                                                            :options="charts.q1Chart.total.options" 
                                                            :key="charts.q1Chart.total.chartKey"
                                                            width="400"
                                                            height="400"
                                                        />
                                                    </div>
                                                    <!-- <div class="chart-container" style="padding: 0px 40px 40px 40px; max-width: 400px;">
                                                        <CustomDoughnutChart
                                                            :data="charts.q1Chart.total.data2"
                                                        />
                                                    </div> -->
                                                </div>
                                            </div>
                                        </card-container>
                                        <card-container
                                            needsBorder
                                            style="flex: 1"
                                        >
                                            <template #title>
                                                <div class="card-title-container">
                                                    <div class="question-chip">Q2</div>자이스 스마일 프로에 대하여 광고나 정보를 어떤 대상을 통해 접하였나요? 
                                                </div>
                                            </template>
                                            <template #button>
                                                <a-button
                                                    shape="circle"
                                                    @click.prevent="uiHandler.downloadPdf($event, 5)"
                                                >
                                                    <template #icon>
                                                        <i class="fa-solid fa-down-to-bracket"/>
                                                    </template>
                                                </a-button>
                                            </template>
                                            <div ref="chart5">
                                                <div v-if="events.summary.list[0]" class="rank-description">
                                                    1번 문항 "예"로 대답한 
                                                    <span class="desc-highlight-text">{{ formatCommaNumber(events.summary.list[0].surveyResults.total.Q1.yes) }}</span>
                                                    명 대상 응답, 복수 응답 가능<br />
                                                    <span class="desc-highlight-text">"{{ displayValues.q2.mostLabel }}"</span> 응답이 가장 높아요.
                                                </div>
                                                <div class="chart-container" style="padding: 0 20px 20px 20px;">
                                                    <custom-bar-chart 
                                                        :data="charts.q2Chart.total.data2"
                                                    />
                                                </div>
                                            </div>
                                        </card-container>
                                    </div>
                                    <div style="display: flex; gap: 20px; flex: 1">
                                        <card-container
                                            needsBorder
                                            style="flex: 1"
                                        >
                                            <template #title>
                                                <div class="card-title-container">
                                                    <div class="question-chip">Q3</div>자이스 스마일 프로 선택 시 함께 고민했던 시술이 있나요?
                                                </div>
                                            </template>
                                            <template #button>
                                                <a-button
                                                    shape="circle"
                                                    @click.prevent="uiHandler.downloadPdf($event, 6)"
                                                >
                                                    <template #icon>
                                                        <i class="fa-solid fa-down-to-bracket"/>
                                                    </template>
                                                </a-button>
                                            </template>
                                            <div class="rank-info-container" ref="chart6">
                                                <div v-if="charts.q3Chart.total.data[0]" class="rank-description">
                                                    <span class="desc-highlight-text">"{{ charts.q3Chart.total.data[0].label }}"</span> 응답이 가장 높아요.
                                                </div>
                                                <div 
                                                    class="rank-item-container" 
                                                    :class="index === 0 ? 'first' : ''"
                                                    v-for="(item, index) in charts.q3Chart.total.data"
                                                >
                                                    <div class="rank-box">{{ index + 1 }}위</div>
                                                    <div class="rank-content">{{ item.label }}</div>
                                                    <div class="rank-number-box">
                                                        <div class="rank-percentage">{{ item.percentage }}</div>
                                                        <div class="rank-number">{{ item.value }}건</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </card-container>
                                        <card-container
                                            :title="charts.q4Chart.total.question"
                                            needsBorder
                                            style="flex: 1;"
                                        >
                                            <template #title>
                                                <div class="card-title-container">
                                                    <div class="question-chip">Q4</div>스마일 라식 종류 중 수술 전 알고 있던 수술(장비)이 있을까요?
                                                </div>
                                            </template>
                                            <template #button>
                                                <a-button
                                                    shape="circle"
                                                    @click.prevent="uiHandler.downloadPdf($event, 7)"
                                                >
                                                    <template #icon>
                                                        <i class="fa-solid fa-down-to-bracket"/>
                                                    </template>
                                                </a-button>
                                            </template>
                                            <div class="rank-info-container" ref="chart7">
                                                <div v-if="charts.q4Chart.total.data[0]" class="rank-description">
                                                    복수 응답 가능<br />
                                                    <span class="desc-highlight-text">"{{ charts.q4Chart.total.data[0].label }}"</span>
                                                     응답이 가장 높아요.
                                                </div>
                                                <div 
                                                    class="rank-item-container" 
                                                    :class="index === 0 ? 'first' : ''"
                                                    v-for="(item, index) in charts.q4Chart.total.data"
                                                >
                                                    <div class="rank-box">{{ index + 1 }}위</div>
                                                    <div class="rank-content">{{ item.label }}</div>
                                                    <div class="rank-number-box">
                                                        <div class="rank-percentage">{{ item.percentage }}</div>
                                                        <div class="rank-number">{{ item.value }}건</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </card-container>
                                    </div>
                                    <div style="display: flex; gap: 20px; flex: 1">
                                        <card-container
                                            needsBorder
                                            style="flex: 1"
                                        >
                                            <template #title>
                                                <div class="card-title-container">
                                                    <div class="question-chip">Q5</div>여러 스마일 라식 중 자이스 스마일 프로(비쥬맥스 800)를 선택한 이유가 있나요?
                                                </div>
                                            </template>
                                            <template #button>
                                                <a-button
                                                    shape="circle"
                                                    @click.prevent="uiHandler.downloadPdf($event, 8)"
                                                >
                                                    <template #icon>
                                                        <i class="fa-solid fa-down-to-bracket"/>
                                                    </template>
                                                </a-button>
                                            </template>
                                            <div ref="chart8">
                                                <div class="rank-description">
                                                    복수 응답 가능<br />
                                                    <span class="desc-highlight-text">"{{ displayValues.q5.mostLabel }}"</span>
                                                     응답이 가장 높아요.
                                                </div>
                                                <div class="chart-container" style="padding: 0 20px 20px 20px;">
                                                    <!-- <Bar
                                                        :data="charts.q5Chart.total.data" 
                                                        :options="charts.q5Chart.total.options" 
                                                        :key="charts.q5Chart.total.chartKey"
                                                    /> -->
                                                    <custom-bar-chart 
                                                        :data="charts.q5Chart.total.data2"
                                                    />
                                                </div>
                                            </div>
                                        </card-container>
                                        <card-container
                                            needsBorder
                                            style="flex: 1"
                                        >
                                            <template #title>
                                                <div class="card-title-container">
                                                    <div class="question-chip">Q6</div>6번 해당 병원에서 수술 받기로 결정한 이유가 있나요?
                                                </div>
                                            </template>
                                            <template #button>
                                                <a-button
                                                    shape="circle"
                                                    @click.prevent="uiHandler.downloadPdf($event, 9)"
                                                >
                                                    <template #icon>
                                                        <i class="fa-solid fa-down-to-bracket"/>
                                                    </template>
                                                </a-button>
                                            </template>
                                            <div ref="chart9" style="height: 100%;">
                                                <div class="rank-description">
                                                    복수 응답 가능<br />
                                                    <span class="desc-highlight-text">"{{ displayValues.q6.mostLabel }}"</span> 응답이 가장 높아요.
                                                </div>
                                                <div class="chart-container" style="padding: 30px 20px 20px 20px; height: 100;">
                                                    <custom-bar-chart 
                                                        :data="charts.q6Chart.total.data2"
                                                        :gap="'40px'"
                                                    />
                                                <div style="height: 40px; width: 100%;" />

                                                </div>
                                            </div>
                                        </card-container>
                                    </div>
                                </div>
                                <div class="summary-right">
                                    <card-container
                                        title="병원별 응답자 수"
                                        needsBorder
                                    >
                                        <template #button>
                                            <a-button
                                                shape="circle"
                                                @click.prevent="uiHandler.downloadPdf($event, 10)"
                                            >
                                                <template #icon>
                                                    <i class="fa-solid fa-down-to-bracket"/>
                                                </template>
                                            </a-button>
                                        </template>
                                        <div 
                                            class="hospital-container"
                                            v-if="events.summary.list[0] && events.summary.list[0].hospitalRankings"
                                            ref="chart10"
                                        >
                                            <a-tooltip
                                                v-for="(hospital, index) in events.summary.list[0].hospitalRankings"
                                                :key="index"
                                            >
                                                <template #title>
                                                    <div class="hospital-tooltip" style="display: flex; flex-direction: column;">
                                                        <span>자이스 스마일 발행건수: {{ hospital.smileCount }}</span>
                                                        <span>자이스 스마일 프로 발행건수: {{ hospital.smileProCount }}</span>
                                                    </div>
                                                </template>
                                                <div class="hospital-row" >
                                                    <div class="rank-title">
                                                        {{ index + 1 }}위
                                                    </div>
                                                    <div class="hospital-name">
                                                        {{ hospital.companyName }}
                                                    </div>
                                                    <div class="hospital-number">
                                                        ({{ hospital.responseCount }}건)
                                                    </div>
                                                </div>
                                            </a-tooltip>
                                        </div>
                                    </card-container>
                                    
                                </div>
                            </div>
                           
                            <div class="no-result-container" v-show="!dataLoading && events.summary.list.length ===  0">
                                <i class="fa-solid fa-exclamation-triangle"/>
                                <span v-if="!dataLoading">{{ computedNoResultMessage }} </span>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div class="no-result-container" v-show="!dataLoading && events.summary.list.length ===  0">
                    <i class="fa-solid fa-exclamation-triangle"/>
                    <span v-if="!dataLoading">{{ computedNoResultMessage }} </span>
                </div>
            </div>
        </div>
    </div>
    <div style="display: flex; flex-direction: column; gap: 16px;" v-else>
        <div class="no-result-container">
            <i class="fa-solid fa-exclamation-triangle"/>
            <span>조회 기간에 대한 데이터가 없습니다.</span>
        </div>
    </div>
</template>
<script>
import Pagination from "@/views/components/Pagination.vue";
import eventApis from "@/views/EventManagement/api";
import {
  formatCommaNumber,
  oneBtnDialog,
} from "@/utils/utils";
import dayjs from "dayjs";
import 'dayjs/locale/ko'
import locale from "ant-design-vue/es/date-picker/locale/ko_KR";
import CardContainer from "@/views/EventManagement/components/CardContainer.vue";
import StatContainer from "@/views/EventManagement/components/StatContainer.vue";
import ItemsContainer from "@/views/EventManagement/components/ItemsContainer.vue";
import GrowthContainer from "@/views/EventManagement/components/GrowthContainer.vue";
import CustomBarChart from "@/views/EventManagement/components/CustomBarChart.vue";
import CustomDoughnutChart from "@/views/EventManagement/components/CustomDoughnutChart.vue";
import { Bar, Pie, Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement, } from 'chart.js'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement)


export default {
    components: {
        Pagination, 
        CardContainer,
        StatContainer,
        ItemsContainer,
        GrowthContainer,
        CustomBarChart,
        CustomDoughnutChart,
        Bar,
        Pie,
        Doughnut,
    },
    computed: {
        noResult() {
            return !this.$store.state.isLoading && this.eventData.totalDocs === 0
        },
        computedNoResultMessage() {
            return this.$i18n.t('noresult_event');
        },
        statusList() {
            return [
                {label: '전체', value: '전체'},
                {label: '예정', value: '예정'},
                {label: '진행중', value: '진행중'},
                {label: '종료', value: '종료'},
            ]
        },
        combinedData() {
            return this.eventData;
        },
        surveyResultsArray() {
            const result = {};

            if (this.events.surveyResults && this.events.surveyResults.total) {
                Object.entries(this.events.surveyResults.total).forEach(([questionKey, answers]) => {
                    const total = Object.values(answers).reduce((sum, count) => sum + count, 0);
                    result[questionKey] = Object.entries(answers)
                        .sort(([a], [b]) => {
                            // 'yes'를 우선순위로 정렬
                            if (a === 'yes') return -1;
                            if (b === 'yes') return 1;
                            return 0;
                        })
                        .map(([answer, count]) => ({
                            question: answer,
                            count: formatCommaNumber(count),
                            ratio: `(${((count / total)* 100).toFixed(1)}%)`
                        }));
                });
            }
            console.log(result)
            return result;
        },
        participationRate() {
            if(!this.events.summary.list[0]) return 0;
            return Math.round((this.events.summary.list[0].responseCount / this.events.summary.list[0].totalSent) * 10000) / 100; // 소수점 둘째 자리에서 반올림
        },
        computedCurrentTab() {
            return this.currentTab
        }
    },
    props: {
        eventData: Object,
        currentTab: Number,
    },
    watch: {
        combinedData: {
            handler(newData) {
                if (newData) {
                    if(!newData.eventStats || !newData.summary) return;
                    this.uiHandler.processEventStats(newData);
                }
            },
            immediate: true,
        },
        computedCurrentTab: {
            handler(newData) {
            },
            immediate: true,
        },
        'events.summary.list': {
            handler() {
                this.uiHandler.updateCharts();
            },
            deep: true
        },
    },
    data() {
        return {
            uiHandler: this.ui(),
            apiHandler: this.api(),
            formatCommaNumber,
            locale,
            dataLoading: false,
            modal: {
                createEvent: {
                    show: false
                },
            },
            events: {
                startAt: null,
                endAt: null,
                totalDocs: 0,
                list: [],
                selectedRound: -2,
                eventRounds: [],
                summary: {
                    list: [],
                },
                surveyResults: {},
            },
            displayValues: {
                gender: {
                    maleRatio: 0,
                    femaleRatio: 0,
                },
                age: {
                    topAgeLabel: '',
                    topAgeValue: '',
                },
                afterSurgery: {
                    afterSurgeryResponseMostLabel: '',
                    afterSurgeryResponse: {
                        '1개월 이내': 0,
                        '1-3개월 경과': 0,
                        '3-6개월 경과': 0,
                        '6개월 이상': 0,
                    }
                },
                q2: {
                    mostLabel: '',
                },
                q5: {
                    mostLabel: '',
                },
                q6: {
                    mostLabel: '',
                },
            },
            charts: {
                hourlyChart: {
                    data: {
                        labels: [],
                        datasets: [{
                            label: '시간별 응답 수',
                            data: [],
                            backgroundColor: 'rgba(75, 192, 192, 0.6)',
                            borderColor: 'rgba(75, 192, 192, 1)',
                            borderWidth: 1
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                beginAtZero: true,
                                title: {
                                    display: true,
                                    text: '응답 수'
                                }
                            },
                            x: {
                                title: {
                                    display: true,
                                    text: '시간'
                                }
                            }
                        },
                        plugins: {
                            tooltip: {
                                callbacks: {
                                    label: (context) => {
                                        const label = context.dataset.label || '';
                                        const value = context.parsed.y;
                                        const percentage = this.events.summary.list[0].hourlyStats.total[context.dataIndex].percentage;
                                        return `${label}: ${value} (${percentage})`;
                                    }
                                }
                            }
                        }
                    },
                    chartKey: 0,
                },
                itemRatioChart: {
                    data: {
                        labels: ['스마일', '스마일 프로'],
                        datasets: [{
                            data: [0, 0],
                            backgroundColor: ['#1626B6', '#676767'],
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                    },
                    chartKey: 0,
                },
                genderChart: {
                    data: {
                        labels: ['남성', '여성', '알 수 없음'],
                        datasets: [{
                            data: [0, 0, 0],
                            backgroundColor: ['#FF6384', '#36A2EB', 'gray'],
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                    },
                    chartKey: 0,
                },
                ageChart: {
                    data: {
                        labels: ['20~24세', '25~29세', '30~34세', '35~39세', '40세 이상', '연령 미상'],
                        datasets: [{
                            data: [0, 0, 0, 0, 0, 0],
                            backgroundColor: ['#278AEC', '#F55247', '#FFCE56', '#4CAF50', '#FF6384', '#ACB2B9'],
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                    },
                    chartKey: 0,
                },
                recoveryChart: {
                    data: {
                        labels: [],
                        datasets: [{
                            label: '수술 후 기간별 응답 수',
                            data: [],
                            backgroundColor: 'rgba(75, 192, 192, 0.6)',
                            borderColor: 'rgba(75, 192, 192, 1)',
                            borderWidth: 1
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                beginAtZero: true,
                                title: {
                                    display: true,
                                    text: '응답 수'
                                }
                            },
                            x: {
                                title: {
                                    display: true,
                                    text: '시간'
                                }
                            }
                        },
                        plugins: {
                            tooltip: {
                                callbacks: {
                                    label: (context) => {
                                        const label = context.dataset.label || '';
                                        const value = context.parsed.y;
                                        const percentage = this.events.summary.list[0].hourlyStats[context.dataIndex].percentage;
                                        return `${label}: ${value} (${percentage})`;
                                    }
                                }
                            }
                        }
                    },
                    chartKey: 0,
                },
                q1Chart: {
                    total: {
                        question: '1번.스마일 라식 중 자이스 스마일과 스마일 프로를 안과 방문전 들어본적 있나요?',
                        data2: [],
                        data: {
                            labels: ['예', '아니오'],
                            datasets: [{
                                data: [0, 0, ],
                                backgroundColor: ['#FF6384', '#36A2EB'],
                            }]
                        },
                        options: {},
                        chartKey: 0,
                    },
                },
                q2Chart: {
                    total: {
                        question: '2번. 자이스 스마일 프로에 대하여 광고나 정보를 어떤 대상을 통해 접하였나요?',
                        data2: [],
                        data: {
                            labels: [],
                            datasets: [{
                                data: [],
                                backgroundColor: [
                                    '#F55247', '#FEA47F', '#25CCF7', '#EAB543', '#55E6C1', 
                                    '#F97F51', '#1B9CFC', '#F8EFBA', '#58B19F', '#2C3A47', 
                                    '#D6A2E8', '#BDC581'
                                ], 
                                barThickness: 20,
                            }]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            indexAxis: 'y', 
                            scales: {
                                x: {
                                    ticks: {
                                        font: {
                                            size: 12
                                        },
                                    }
                                },
                                y: {
                                    ticks: {
                                        font: {
                                            size: 12
                                        },
                                        align: 'center',
                                        padding: 15,
                                    }
                                }
                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            return '';
                                        }
                                    }
                                },
                                legend: {
                                    display: false,
                                    onClick: null,
                                    position: 'bottom',
                                    align: 'start',
                                },
                                datalabels: {
                                    display: true,
                                    color: 'black', // 글씨 색상 하얀색
                                    formatter: (value) => {
                                        return value;
                                    }
                                },
                            }
                        },
                        chartKey: 0,
                    },
                },
                q3Chart: {
                    total: {
                        question: '3번. 자이스 스마일 라식 선택 시 함께 고민했던 시술이 있나요?',
                        data: [],
                        options: {},
                        chartKey: 0,
                    },
                },
                q4Chart: {
                    total: {
                        question: '4번. 스마일 라식 종류 중 수술 전 알고 있던 수술(장비)이 있을까요?',
                        data: [],
                        options: {},
                        chartKey: 0,
                    },
                },
                q5Chart: {
                    total: {
                        question: '5번. 여러 스마일 라식 중 자이스 스마일 라식(비쥬맥스)을 선택한 이유가 있나요?',
                        data2: [],
                        data: {
                            labels: [],
                            datasets: [{
                                data: [],
                                backgroundColor: [
                                    '#F55247', '#FEA47F', '#25CCF7', '#EAB543', '#55E6C1', 
                                    '#F97F51', '#1B9CFC', '#F8EFBA', '#58B19F', '#2C3A47', 
                                    '#D6A2E8', '#BDC581'
                                ], 
                                barThickness: 15,
                            }]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            indexAxis: 'y', 
                            scales: {
                                x: {
                                    ticks: {
                                        font: {
                                            size: 12,
                                        },
                                    }
                                },
                                y: {
                                    ticks: {
                                        font: {
                                            size: 12
                                        },
                                        align: 'center',
                                        padding: 15,
                                    },
                                }
                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            return '';
                                        }
                                    }
                                },
                                legend: {
                                    display: false,
                                    onClick: null,
                                    position: 'bottom',
                                    align: 'start',
                                },
                                datalabels: {
                                    display: true,
                                    color: 'black',
                                    formatter: (value) => {
                                        return value;
                                    }
                                },
                            }
                        },
                        chartKey: 0,
                    },
                },
                q6Chart: {
                    total: {
                        question: '6번. 해당 병원에서 수술 받기로 결정한 이유가 있나요?',
                        data2: [],
                        data: {
                            labels: [],
                            datasets: [{
                                data: [],
                                backgroundColor: [
                                    '#F55247', '#FEA47F', '#25CCF7', '#EAB543', '#55E6C1', 
                                    '#F97F51', '#1B9CFC', '#F8EFBA', '#58B19F', '#2C3A47', 
                                    '#D6A2E8', '#BDC581'
                                ], 
                                barThickness: 15,
                            }]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            indexAxis: 'y', 
                            scales: {
                                x: {
                                    ticks: {
                                        font: {
                                            size: 12,
                                        },
                                    }
                                },
                                y: {
                                    ticks: {
                                        font: {
                                            size: 12,
                                        },
                                        align: 'center',
                                        padding: 15,
                                    }
                                }
                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            return '';
                                        }
                                    }
                                },
                                legend: {
                                    display: false,
                                    onClick: null,
                                    position: 'bottom',
                                    align: 'start',
                                },
                                datalabels: {
                                    display: true,
                                    color: 'black',
                                    formatter: (value) => {
                                        return value;
                                    }
                                },
                            }
                        },
                        chartKey: 0,
                    },
                },
            },
        }
    },
    async mounted() {
        // await this.uiHandler.search();
    },
    methods: {
        dayjs,
        ui() {
            return {
                updateCharts: () => {
                    this.uiHandler.updateHourlyChartData();
                    this.uiHandler.updateItemRatioChartData();
                    this.uiHandler.updateGenderChartData();
                    this.uiHandler.updateAgeChartData();
                    this.uiHandler.updateRecoveryChartData();
                    this.uiHandler.updateQ1ChartData();
                    this.uiHandler.updateQ2ChartData();
                    this.uiHandler.updateQ3ChartData();
                    this.uiHandler.updateQ4ChartData();
                    this.uiHandler.updateQ5ChartData();
                    this.uiHandler.updateQ6ChartData();
                },
                processEventStats: (data) => {
                    this.events.list = data.eventStats.map(item => {
                        return {
                            ...item.statsData,
                            ...item,
                        }
                    });
                    this.events.summary.list = [data.summary];
                    this.events.surveyResults = data.summary.surveyResults;
                },
                getFileName: (index) => {
                    switch(index) {
                        case 0:
                            return '전체_전체 누적 이벤트 현황';
                        case 1:
                            return '전체_시간대별 인증서 발행 및 응모자 추이';
                        case 2:
                            return '전체_수술 경과 기간별 응답률';
                        case 3:
                            return '전체_참여자 성별 및 나이 분포';
                        case 4:
                            return '전체_Q1';
                        case 5:
                            return '전체_Q2';
                        case 6:
                            return '전체_Q3';
                        case 7:
                            return '전체_Q4';
                        case 8:
                            return '전체_Q5';
                        case 9:
                            return '전체_Q6';
                        case 10:
                            return '전체_병원별 응답자 수';
                        default:
                            return '전체_설문이벤트 데이터';
                    }
                },
                downloadPdf: async (event, index) => {
                    event.preventDefault(); // 기본 동작 방지
                    event.stopPropagation(); // 이벤트 전파 방지
                    this.$store.commit('setIsLoading', true);

                    const element = this.$refs[`chart${index}`];
                    if (!element) {
                        this.localLoading = false;
                        return;
                    }

                    try {
                        // HTML 요소를 캔버스로 변환
                        const canvas = await html2canvas(element, { scale: 3, useCORS: true });
                        const imgData = canvas.toDataURL('image/png', 0.9);

                        // jsPDF 인스턴스 생성 (A4 사이즈, 가로 방향)
                        const pdf = new jsPDF('landscape', 'mm', 'a4');
                        const pdfWidth = pdf.internal.pageSize.getWidth(); // 297mm
                        const pdfHeight = pdf.internal.pageSize.getHeight(); // 210mm
                        const margin = 10; // 10mm 마진

                        // PDF 내에 삽입할 콘텐츠 영역 계산
                        const contentWidth = pdfWidth - 2 * margin; // 277mm
                        const contentHeight = pdfHeight - 2 * margin; // 190mm

                        // 캔버스의 실제 크기
                        const imgWidth = canvas.width;
                        const imgHeight = canvas.height;

                        // PDF에 맞게 스케일링 비율 계산
                        const widthRatio = contentWidth / imgWidth;
                        const heightRatio = contentHeight / imgHeight;
                        const scale = Math.min(widthRatio, heightRatio);

                        // 최종 이미지 크기
                        const finalWidth = imgWidth * scale;
                        const finalHeight = imgHeight * scale;

                        // 이미지가 PDF 페이지 내에서 중앙에 위치하도록 X, Y 좌표 계산
                        const x = (pdfWidth - finalWidth) / 2;
                        const y = (pdfHeight - finalHeight) / 2;

                        // PDF에 이미지 추가
                        pdf.addImage(
                            imgData,
                            'PNG',
                            x,
                            y,
                            finalWidth,
                            finalHeight
                        );

                        // PDF 저장
                        pdf.save(`${this.uiHandler.getFileName(index)}.pdf`);
                    } catch (error) {
                        console.error('PDF 다운로드 오류:', error);
                    } finally {
                        this.$store.commit('setIsLoading', false);
                    }
                },
                updateItemRatioChartData:() => {
                    if (this.events.summary.list[0]) {
                        const smileCount = this.events.summary.list[0]?.smileCount || 0;
                        const smileProCount = this.events.summary.list[0]?.smileProCount || 0;
                        this.charts.itemRatioChart.data.datasets[0].data = [smileCount, smileProCount];
                        this.charts.itemRatioChart.options.plugins = {
                            tooltip: {
                                callbacks: {
                                    label: (context) => {
                                        const label = context.label || '';
                                        const value = context.raw; // 원래 값
                                        const total = this.events.summary.list[0]?.smileCount + this.events.summary.list[0]?.smileProCount || 0;
                                        const percentage = total > 0 ? Math.round((value / total) * 100) + '%' : '0%';
                                        return `${label}: ${value.toLocaleString()}명 (${percentage})`;
                                    }
                                }
                            },
                            datalabels: {
                                display: true,
                                color: 'white', // 글씨 색상 하얀색
                                formatter: (value) => {
                                    const total = this.events.summary.list[0]?.smileCount + this.events.summary.list[0]?.smileProCount || 0;
                                    const percentage = total > 0 ? Math.round((value / total) * 100).toFixed(1) + '%' : '0%';
                                    return percentage;
                                }
                            },
                            legend: {
                                onClick: null,
                                display: true,
                                position: 'right',
                                align: 'start',
                                // labels: {
                                //     boxWidth: 15,
                                //     padding: 15,
                                //     textAlign: 'right',
                                //     generateLabels: (chart) => {
                                //         return [
                                //             { text: '가장 많음', fillStyle: '#F55247' },
                                //             { text: '가장 적음', fillStyle: '#278AEC' },
                                //         ];
                                //     }
                                // }
                            },
                        }
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.itemRatioChart.chartKey += 1;
                    }
                },
                updateHourlyChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].hourlyStats) {
                        const hourlyStats = this.events.summary.list[0].hourlyStats.total;
                        const groupedStats = hourlyStats.reduce((acc, stat) => {
                            if (stat.hour >= 0 && stat.hour <= 7) {
                                // 0~7시의 경우
                                if (!acc[0]) {
                                    acc[0] = { hour: '0~7', count: 0, percentage: '0%' };
                                }
                                acc[0].count += stat.count;
                            } else {
                                // 8시 이후의 경우
                                acc.push(stat);
                            }
                            return acc;
                        }, []);
                        
                        const counts = groupedStats.map(stat => stat.count);
                        const minCount = Math.min(...counts);
                        const maxCount = Math.max(...counts);

                        this.charts.hourlyChart.data = {
                            labels: groupedStats.map(stat => `${stat.hour}시`),
                            datasets: [{
                                label: '시간별 응답 수',
                                data: counts,
                                backgroundColor: counts.map(count => {
                                    if (count === minCount) return '#278AEC';
                                    if (count === maxCount) return '#F55247';
                                    return '#ACB2B9'; // 평균 (청록색)
                                }),
                                barThickness: 15,
                            }]
                        };


                        this.charts.hourlyChart.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    title: {
                                        display: true,
                                        text: '응답 시간대'
                                    }
                                },
                                y: {
                                    beginAtZero: true,
                                    title: {
                                        display: true,
                                        text: '응답 수'
                                    },
                                    ticks: {
                                        display: true,
                                        callback: function(value) {
                                            if (value % 1 === 0) {
                                                return value.toLocaleString();
                                            }
                                        }
                                    }
                                },

                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const label = context.dataset.label || '';
                                            const value = context.parsed.y;
                                            const percentage = this.events.summary.list[0].hourlyStats.total[context.dataIndex].percentage;
                                            return `${label}: ${value.toLocaleString()}명 (${percentage})`;
                                        }
                                    }
                                },
                                legend: {
                                    display: true,
                                    onClick: null,
                                    position: 'right',
                                    align: 'start',
                                    labels: {
                                        boxWidth: 15,
                                        padding: 15,
                                        textAlign: 'right',
                                        generateLabels: (chart) => {
                                            return [
                                                { text: '가장 많음', fillStyle: '#F55247' },
                                                { text: '가장 적음', fillStyle: '#278AEC' },
                                            ];
                                        }
                                    }
                                },
                                datalabels: {
                                    display: false
                                }
                            }
                        };
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.hourlyChart.chartKey += 1;
                    }
                },
                updateGenderChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].genderStats) {
                        const genderStats = this.events.summary.list[0].genderStats.total;
                        this.charts.genderChart.data = {
                            labels: ['남성', '여성', '알 수 없음'],
                            datasets: [{
                                label: '성별 응답 수',
                                data: [genderStats.male, genderStats.female, genderStats.unknown],
                                backgroundColor: ['#278AEC', '#F55247', '#ACB2B9'], // 각 성별에 대한 색상
                                barThickness: 15,
                            }]
                        };
                        const total = genderStats.male + genderStats.female;

                        const malePercentage = total > 0 ? ((genderStats.male / total) * 100).toFixed(1) : 0;
                        const femalePercentage = total > 0 ? ((genderStats.female / total) * 100).toFixed(1) : 0;
                        
                        this.displayValues.gender.maleRatio = malePercentage;
                        this.displayValues.gender.femaleRatio = femalePercentage;

                        this.charts.genderChart.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const label = context.label || '';
                                            const value = context.parsed;
                                            const percentage = ((value / total) * 100).toFixed(1);
                                            return `${label}: ${value.toLocaleString()}명 (${percentage}%)`;
                                        }
                                    }
                                },
                                legend: {
                                    display: true,
                                    onClick: null,
                                    position: 'right',
                                    align: 'start',
                                    labels: {
                                        boxWidth: 15,
                                        padding: 15,
                                        textAlign: 'left',
                                        generateLabels: (chart) => {
                                            return [
                                                { text: '남성', fillStyle: '#278AEC' },
                                                { text: '여성', fillStyle: '#F55247' },
                                                { text: '알 수 없음', fillStyle: '#ACB2B9' }
                                            ];
                                        }
                                    }
                                },
                                datalabels: {
                                    display: true,
                                    color: 'white', // 글씨 색상 하얀색
                                    formatter: (value) => {
                                        return `${(value / total * 100).toFixed(1)}%`;
                                        // const total = this.events.summary.list[0]?.smileCount + this.events.summary.list[0]?.smileProCount || 0;
                                        // const percentage = total > 0 ? Math.round((value / total) * 100) + '%' : '0%';                                    return percentage;
                                    }
                                },
                                // datalabels: {
                                //     display: false
                                // }
                            }
                        };
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.genderChart.chartKey += 1;
                    }
                },
                updateAgeChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].ageGroupStats) {
                        const ageGroupStats = this.events.summary.list[0].ageGroupStats.total;
                        const ageLabels = Object.keys(ageGroupStats); // 연령대 라벨
                        const ageData = Object.values(ageGroupStats); // 연령대 데이터
                        const total = ageData.reduce((sum, value) => sum + value, 0);

                        const backgroundColors = ['#278AEC', '#F55247', '#FFCE56', '#4CAF50', '#FF6384', '#ACB2B9'];

                        const maxAgeIndex = ageData.indexOf(Math.max(...ageData));
                        const maxAgeLabel = ageLabels[maxAgeIndex];
                        const maxAgeValue = ageData[maxAgeIndex];
                        this.displayValues.age.topAgeLabel = maxAgeLabel;
                        this.displayValues.age.topAgeValue = maxAgeValue;
                        this.charts.ageChart.data = {
                            labels: ageLabels,
                            datasets: [{
                                label: '연령대별 응답 수',
                                data: ageData,
                                backgroundColor: backgroundColors.slice(0, ageData.length), 
                                barThickness: 15,
                            }]
                        };

                        this.charts.ageChart.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const label = context.label || '';
                                            const value = context.parsed;
                                            const percentage = ((value / total) * 100).toFixed(1);
                                            return `${label}: ${value.toLocaleString()}명 (${percentage}%)`;
                                        }
                                    }
                                },
                                legend: {
                                    display: true,
                                    onClick: null,
                                    position: 'right',
                                    align: 'start',
                                    labels: {
                                        boxWidth: 15,
                                        padding: 15,
                                        textAlign: 'left',
                                        generateLabels: (chart) => {
                                            return ageLabels.map((label, index) => ({
                                                text: label,
                                                fillStyle: backgroundColors[index],
                                                hidden: false,
                                                index: index,
                                            }));
                                        }
                                    }
                                },
                                datalabels: {
                                    display: true,
                                    color: 'white', // 글씨 색상 하얀색
                                    formatter: (value) => {
                                        return `${(value / total * 100).toFixed(1)}%`;
                                        // const total = this.events.summary.list[0]?.smileCount + this.events.summary.list[0]?.smileProCount || 0;
                                        // const percentage = total > 0 ? Math.round((value / total) * 100) + '%' : '0%';                                    return percentage;
                                    }
                                },
                                // datalabels: {
                                //     display: false
                                // }
                            }
                        };
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.ageChart.chartKey += 1;
                    }
                },
                updateRecoveryChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].recoveryStats) {
                        const recoveryStats = this.events.summary.list[0].recoveryStats.total;
                        
                        // 라벨과 데이터 배열 생성
                        const labels = Object.keys(recoveryStats); // ["1개월 이내", "1-3개월 이후", "3-6개월 이후", "6개월 이상", "미상"]
                        const data = Object.values(recoveryStats); // [9, 9, 6, 5, 0]
                        const totalResponses = data.reduce((sum, value) => sum + value, 0);
                        
                        // '미상' 항목의 인덱스 찾기
                        const unknownIndex = labels.indexOf('미상');
                        
                        // '미상' 항목이 0일 경우 해당 항목만 제거
                        if (unknownIndex !== -1 && data[unknownIndex] === 0) {
                            labels.splice(unknownIndex, 1); // '미상' 라벨 제거
                            data.splice(unknownIndex, 1); // '미상' 데이터 제거
                        }

                        let maxResponseCount = 0;
                        let maxResponseLabel = '';
                        for (const [key, value] of Object.entries(recoveryStats)) {
                            if (value > maxResponseCount) {
                                maxResponseCount = value;
                                maxResponseLabel = key;
                            }
                        }

                        // displayValues에 값 설정
                        this.displayValues.afterSurgery.afterSurgeryResponseMostLabel = maxResponseLabel;

                        this.charts.recoveryChart.data = {
                            labels: labels,
                            datasets: [{
                                label: '수술 경과 기간별 응답 수',
                                data: data,
                                backgroundColor: [
                                    '#FF6384', // 1개월 이내
                                    '#36A2EB', // 1-3개월 이후
                                    '#FFCE56', // 3-6개월 이후
                                    '#4CAF50', // 6개월 이상
                                    // '미상' 항목은 제거되므로 추가하지 않음
                                ],
                            }]
                        };

                        this.charts.recoveryChart.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            const label = context.label || '';
                                            const value = context.raw; // 원래 값
                                            return `${label}: ${value}명`;
                                        }
                                    }
                                },
                                datalabels: {
                                    display: true,
                                    color: 'white', // 글씨 색상 하얀색
                                    formatter: (value) => {
                                        const percentage = totalResponses > 0 ? ((value / totalResponses) * 100).toFixed(1) + '%' : '0%'; // 퍼센트 계산
                                        return percentage; 
                                    }
                                },
                                legend: {
                                    display: true,
                                    position: 'top',
                                }
                            }
                        };

                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.recoveryChart.chartKey += 1;
                    }
                },
                updateQ1ChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].surveyResults && this.events.summary.list[0].surveyResults.total && this.events.summary.list[0].surveyResults.total.Q1) {
                        const q1Stats = this.events.summary.list[0].surveyResults.total.Q1;
                        const totalResponses = q1Stats.yes + q1Stats.no; 

                        this.charts.q1Chart.total.data = {
                            labels: ['들어본 적 있다', '들어본 적 없다'],
                            datasets: [{
                                // label: '성별 응답 수',
                                data: [q1Stats.yes, q1Stats.no],
                                backgroundColor: ['#1626B6', '#EFEFEF'], // 각 성별에 대한 색상
                                barThickness: 15,
                            }]
                        };


                        this.charts.q1Chart.total.options = {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (context) => {
                                            // const label = context.label || '';
                                            // const value = context.parsed;
                                            // const percentage = ((value / total) * 100).toFixed(1);
                                            // return `${label}: ${value.toLocaleString()}명 (${percentage}%)`;
                                        }
                                    }
                                },
                                legend: {
                                    display: false,
                                    onClick: null,
                                    position: 'bottom',
                                    align: 'start',
                                },
                                datalabels: {
                                    display: true,
                                    color: (context) => {
                                        return context.dataIndex === 0 ? 'white' : 'black';
                                    },
                                    formatter: (value, context) => {
                                        const label = context.dataIndex === 0 ? '들어본 적 있다' : '들어본 적 없다';
                                        const percentage = totalResponses > 0 ? ((value / totalResponses) * 100).toFixed(1) + '%' : '0%';
                                        return `${label}\n${value.toLocaleString()}명 (${percentage})`;
                                    }
                                },
                            }
                        };
                        // 차트 리렌더링을 위한 키 업데이트
                        this.charts.q1Chart.chartKey += 1;

                        this.charts.q1Chart.total.data2 = q1Stats;
                    }
                },
                updateQ2ChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].surveyResults && this.events.summary.list[0].surveyResults.total && this.events.summary.list[0].surveyResults.total.Q2) {
                        const q2Stats = this.events.summary.list[0].surveyResults.total.Q2;

                        const labels = Object.keys(q2Stats); // Q2 데이터의 키를 labels로 사용
                        const data = Object.values(q2Stats); // Q2 데이터의 값을 data로 사용
                        let maxResponseCount = 0;
                        let maxResponseLabel = '';
                        for (const [key, value] of Object.entries(q2Stats)) {
                            if (value > maxResponseCount) {
                                maxResponseCount = value;
                                maxResponseLabel = key;
                            }
                        }

                        this.displayValues.q2.mostLabel = maxResponseLabel;
                        const labelColors = data.map(count => count === maxResponseCount ? '#FFFFFF' : '#000000'); // 어두운 배경에 맞는 폰트 색상
                       
                        this.charts.q2Chart.total.data = {
                            labels: labels,
                            datasets: [{
                                // label: '성별 응답 수',
                                data: data,
                                backgroundColor: data.map(count => count === maxResponseCount ? '#1626B6' : '#ACB2B9'), // 가장 높은 응답에만 색상 변경
                                barThickness: 20,
                            }]
                        };
                        this.charts.q2Chart.total.options.plugins.tooltip.callbacks.label = (context) => {
                            const label = context.label || '';
                            const value = context.raw; // 원래 값
                            const total = data.reduce((sum, value) => sum + value, 0); // 총합 계산
                            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%'; // 퍼센트 계산
                            return `${label}: ${formatCommaNumber(value)} (${percentage})`;
                        }

                        this.charts.q2Chart.total.options.plugins.datalabels.color = (context) => {
                            return labelColors[context.dataIndex]; // 각각의 데이터에 대해 색상 적용
                        };

                        this.charts.q2Chart.total.options.plugins.datalabels.formatter = (value) => {
                            const total = data.reduce((sum, value) => sum + value, 0); // 총합 계산
                            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%'; // 퍼센트 계산
                            return `${formatCommaNumber(value)} (${percentage})`;
                        }

                        this.charts.q2Chart.total.chartKey += 1;

                        this.charts.q2Chart.total.data2 = q2Stats;
                    }
                },
                updateQ3ChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].surveyResults && this.events.summary.list[0].surveyResults.total && this.events.summary.list[0].surveyResults.total.Q3) {
                        const q3Stats = this.events.summary.list[0].surveyResults.total.Q3;

                        const totalResponses = Object.values(q3Stats).reduce((sum, value) => sum + value, 0);

                        // Q3 데이터를 기반으로 객체 배열 생성
                        const q3DataArray = Object.entries(q3Stats).map(([key, value]) => {
                            const percentage = ((value / totalResponses) * 100).toFixed(1) + '%'; // 퍼센트 계산
                            return {
                                label: key,
                                percentage: percentage,
                                value: formatCommaNumber(value)
                            };
                        });

                        this.charts.q3Chart.total.data = q3DataArray;
                    }
                },
                updateQ4ChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].surveyResults && this.events.summary.list[0].surveyResults.total && this.events.summary.list[0].surveyResults.total.Q4) {
                        const q4Stats = this.events.summary.list[0].surveyResults.total.Q4;

                        const totalResponses = Object.values(q4Stats).reduce((sum, value) => sum + value, 0);

                        // Q3 데이터를 기반으로 객체 배열 생성
                        const q4DataArray = Object.entries(q4Stats).map(([key, value]) => {
                            const percentage = ((value / totalResponses) * 100).toFixed(1) + '%'; // 퍼센트 계산
                            return {
                                label: key,
                                percentage: percentage,
                                value: formatCommaNumber(value)
                            };
                        });

                        this.charts.q4Chart.total.data = q4DataArray;
                    }
                },
                updateQ5ChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].surveyResults && this.events.summary.list[0].surveyResults.total && this.events.summary.list[0].surveyResults.total.Q5) {
                        const q5Stats = this.events.summary.list[0].surveyResults.total.Q5;

                        const labels = Object.keys(q5Stats); // Q2 데이터의 키를 labels로 사용
                        const data = Object.values(q5Stats); // Q2 데이터의 값을 data로 사용

                        let maxResponseCount = 0;
                        let maxResponseLabel = '';
                        for (const [key, value] of Object.entries(q5Stats)) {
                            if (value > maxResponseCount) {
                                maxResponseCount = value;
                                maxResponseLabel = key;
                            }
                        }

                        this.displayValues.q5.mostLabel = maxResponseLabel;
                        const labelColors = data.map(count => count === maxResponseCount ? '#FFFFFF' : '#000000'); // 어두운 배경에 맞는 폰트 색상

                        this.charts.q5Chart.total.data = {
                            labels: labels,
                            datasets: [{
                                // label: '성별 응답 수',
                                data: data,
                                backgroundColor: data.map(count => count === maxResponseCount ? '#1626B6' : '#ACB2B9'), // 가장 높은 응답에만 색상 변경
                                barThickness: 20,
                            }]
                        };
                      
                        this.charts.q5Chart.total.options.plugins.tooltip.callbacks.label = (context) => {
                            const label = context.label || '';
                            const value = context.raw; // 원래 값
                            const total = data.reduce((sum, value) => sum + value, 0); // 총합 계산
                            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%'; // 퍼센트 계산
                            return `${label}: ${formatCommaNumber(value)} (${percentage})`;
                        }

                        this.charts.q5Chart.total.options.plugins.datalabels.color = (context) => {
                            return labelColors[context.dataIndex]; // 각각의 데이터에 대해 색상 적용
                        };
               
                        this.charts.q5Chart.total.options.plugins.datalabels.formatter = (value) => {
                            const total = data.reduce((sum, value) => sum + value, 0); // 총합 계산
                            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%'; // 퍼센트 계산
                            return `${formatCommaNumber(value)} (${percentage})`;
                        }

                        this.charts.q5Chart.total.chartKey += 1;

                        this.charts.q5Chart.total.data2 = q5Stats;
                    }
                },
                updateQ6ChartData:() => {
                    if (this.events.summary.list[0] && this.events.summary.list[0].surveyResults && this.events.summary.list[0].surveyResults.total && this.events.summary.list[0].surveyResults.total.Q6) {
                        const q6Stats = this.events.summary.list[0].surveyResults.total.Q6;

                        const labels = Object.keys(q6Stats); // Q2 데이터의 키를 labels로 사용
                        const data = Object.values(q6Stats); // Q2 데이터의 값을 data로 사용

                        let maxResponseCount = 0;
                        let maxResponseLabel = '';
                        for (const [key, value] of Object.entries(q6Stats)) {
                            if (value > maxResponseCount) {
                                maxResponseCount = value;
                                maxResponseLabel = key;
                            }
                        }

                        this.displayValues.q6.mostLabel = maxResponseLabel;
                        const labelColors = data.map(count => count === maxResponseCount ? '#FFFFFF' : '#000000'); // 어두운 배경에 맞는 폰트 색상

                        this.charts.q6Chart.total.data = {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: data.map(count => count === maxResponseCount ? '#1626B6' : '#ACB2B9'), // 가장 높은 응답에만 색상 변경
                                barThickness: 20,
                            }]
                        };
                      
                        this.charts.q6Chart.total.options.plugins.tooltip.callbacks.label = (context) => {
                            const label = context.label || '';
                            const value = context.raw; // 원래 값
                            const total = data.reduce((sum, value) => sum + value, 0); // 총합 계산
                            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%'; // 퍼센트 계산
                            return `${label}: ${formatCommaNumber(value)} (${percentage})`;
                        }
                        this.charts.q6Chart.total.options.plugins.datalabels.color = (context) => {
                            return labelColors[context.dataIndex]; // 각각의 데이터에 대해 색상 적용
                        };
                        this.charts.q6Chart.total.options.plugins.datalabels.formatter = (value) => {
                            const total = data.reduce((sum, value) => sum + value, 0); // 총합 계산
                            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%'; // 퍼센트 계산
                            return `${formatCommaNumber(value)} (${percentage})`;
                        }

                        this.charts.q6Chart.total.chartKey += 1;
                        this.charts.q6Chart.total.data2 = q6Stats;
                    }
                },
                convertMonthAndYearText: (input) => {
                    if (input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
                    return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
                },
            }
        },
        api() {
            return eventApis(this.$apiInstance, this.$store);
        }
    }
}
</script>
<style lang="scss">
  @import '@/views/EventManagement/event.scss';
</style>